import React, { useState } from 'react';
import Hero from '../components/home/Hero';
import FeaturedSlider from '../components/home/FeaturedSlider';
import ArtistPreview from '../components/home/ArtistPreview';
import RecentWorks from '../components/home/RecentWorks';
import Modal from '../components/ui/Modal';
import { paintings } from '../data/paintings';

const HomePage = ({ setActiveSection }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPainting, setSelectedPainting] = useState(null);

  const openModal = (painting) => {
    setSelectedPainting(painting);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setSelectedPainting(null), 300);
  };

  const navigatePainting = (direction) => {
    if (!selectedPainting) return;
    const currentIndex = paintings.findIndex(p => p.id === selectedPainting.id);
    let newIndex;

    if (direction === 'next') {
      newIndex = currentIndex === paintings.length - 1 ? 0 : currentIndex + 1;
    } else {
      newIndex = currentIndex === 0 ? paintings.length - 1 : currentIndex - 1;
    }

    setSelectedPainting(paintings[newIndex]);
  };

  return (
    <div>
      <Hero onExplore={() => setActiveSection('gallery')} />
      <FeaturedSlider onViewDetails={openModal} />
      <ArtistPreview onLearnMore={() => setActiveSection('about')} />
      <RecentWorks
        onViewGallery={() => setActiveSection('gallery')}
        onViewPainting={openModal}
      />

      <Modal
        isOpen={modalOpen}
        onClose={closeModal}
        painting={selectedPainting}
        onNext={() => navigatePainting('next')}
        onPrev={() => navigatePainting('prev')}
      />
    </div>
  );
};

export default HomePage;
